import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import styles from "../../pages/Settings/Settings.module.scss";

const EventType = ({
  apiAddFunc,
  buttonLabel,
  listComponent: ListComponent,
  editFormComponent: EditFormComponent,
  component,
  ...props
}) => {
  const [addnewform, setAddNewForm] = React.useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (data) => {
    try {
      if (component === "timeTypes") {
        await dispatch(apiAddFunc(data));
      } else if (component === "activityTypes") {
        await apiAddFunc(data);
        toast.success("Activity Type Added Successfully");
      }
    } catch (error) {
      if (component === "activityTypes") {
        toast.error("Error Occurred");
      }
    } finally {
      setAddNewForm(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setAddNewForm(true);
              props.open();
            }}
          >
            Add <br></br>
            {buttonLabel}
          </Button>
        </div>
        <div className="settings-grid-wrapper">
          <ListComponent />
        </div>
      </>
      {addnewform && (
        <EditFormComponent
          cancelEdit={() => {
            setAddNewForm(false);
          }}
          onSubmit={handleSubmit}
          type="addNew"
        />
      )}
    </React.Fragment>
  );
};

export default EventType;
